import { render, staticRenderFns } from "./WizardStep.vue?vue&type=template&id=397ddf90&"
import script from "./WizardStep.vue?vue&type=script&lang=js&"
export * from "./WizardStep.vue?vue&type=script&lang=js&"
import style0 from "./WizardStep.vue?vue&type=style&index=0&id=397ddf90&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports